export default "__VITE_ASSET__Co21pWGn__"